import { Card, CardContent } from "@/components/ui/card";
import { User, CheckCircle2, Clock, Shield, Users } from "lucide-react";

export const WorkerStats = ({ workers, allUsers }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
      <Card className="bg-[#0A0A0A] border-white/10">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-[#23F7DD]/10 rounded-lg">
              <User className="w-5 h-5 text-[#23F7DD]" />
            </div>
            <div>
              <p className="text-2xl font-bold text-[#23F7DD]">{workers.length}</p>
              <p className="text-xs text-[#94A3B8]">Total</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-[#0A0A0A] border-white/10">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-green-500/10 rounded-lg">
              <CheckCircle2 className="w-5 h-5 text-green-500" />
            </div>
            <div>
              <p className="text-2xl font-bold text-green-500">
                {workers.filter(w => w.is_approved).length}
              </p>
              <p className="text-xs text-[#94A3B8]">Approved</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-[#0A0A0A] border-white/10">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-yellow-500/10 rounded-lg">
              <Clock className="w-5 h-5 text-yellow-400" />
            </div>
            <div>
              <p className="text-2xl font-bold text-yellow-400">
                {workers.filter(w => !w.is_approved).length}
              </p>
              <p className="text-xs text-[#94A3B8]">Pending</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-[#0A0A0A] border-white/10">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-purple-500/10 rounded-lg">
              <Shield className="w-5 h-5 text-purple-400" />
            </div>
            <div>
              <p className="text-2xl font-bold text-purple-400">
                {workers.filter(w => w.profile?.hms_card_status === 'verified').length}
              </p>
              <p className="text-xs text-[#94A3B8]">HMS Verified</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      {/* All Users Card */}
      <Card className="bg-[#0A0A0A] border-white/10">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-500/10 rounded-lg">
              <Users className="w-5 h-5 text-blue-400" />
            </div>
            <div>
              <p className="text-2xl font-bold text-blue-400">{allUsers.length}</p>
              <p className="text-xs text-[#94A3B8]">All Users</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
